import $ from 'jquery';

//@todo remove logging

Drupal.behaviors.toggleMobileMenu = {
  attach: function (context) {
    let $toggleBtn = $('.header__mobile-toggle', context);
    $toggleBtn.click(function() {
      console.log("hello");
      $('.header').toggleClass('mobile-menu--open');
      ($('html').toggleClass('menu-active'));
    });
    $(document).keydown(function(e){
      if ($('html').hasClass('menu-active')) {
        if(e.keyCode == 27) {
          $('html').removeClass('menu-active');
          $('.header').removeClass('mobile-menu--open');
        }
      }
    });
  }
}


